import { NarvarBackSyncStatus } from "@redotech/congo-enums/narvar-back-sync-status";
import * as z from "zod";

const narvarBackSyncStatus = z.object({
  status: z.enum(NarvarBackSyncStatus),
  workflowId: z.string().optional(),
  from: z.date().optional(),
  to: z.date().optional(),
  discovered: z.number(),
  imported: z.number(),
  updated: z.number(),
  skipped: z.number(),
  failed: z.number(),
  startedAt: z.date().optional(),
  completedAt: z.date().optional(),
  cancelledAt: z.date().optional(),
  lastError: z.string().optional(),
});

export const getNarvarIntegration = {
  name: "getNarvarIntegration" as const,
  input: z.object({}),
  output: z.object({
    narvarIntegration: z.optional(
      z.object({
        enabled: z.boolean(),
        username: z.string(),
        hasPassword: z.boolean(),
        backSyncReturns: narvarBackSyncStatus,
        lastSyncedAt: z.date().optional(),
      }),
    ),
  }),
};

export const startNarvarBackSync = {
  name: "startNarvarBackSync" as const,
  input: z
    .object({ from: z.coerce.date(), to: z.coerce.date() })
    .refine(({ from, to }) => from <= to, {
      message: "The start date must be before the end date",
    }),
  output: z.object({ workflowId: z.string() }),
};

export const cancelNarvarBackSync = {
  name: "cancelNarvarBackSync" as const,
  input: z.object({}),
  output: z.object({}),
};

export const setNarvarIntegration = {
  name: "setNarvarIntegration" as const,
  input: z.object({
    username: z.string().trim().min(1, "Username is required"),
    password: z.string().min(1, "Password is required"),
  }),
  output: z.object({}),
};

export const updateNarvarIntegration = {
  name: "updateNarvarIntegration" as const,
  input: z.object({
    username: z.string().trim().min(1, "Username is required").optional(),
    password: z.string().min(1, "Password is required").optional(),
  }),
  output: z.object({}),
};

export const disconnectNarvarIntegration = {
  name: "disconnectNarvarIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
